export default {
  common: {
    error: "Đã xảy ra lỗi",
    reload: "Tải lại",
    errorNotification: "Chúng tôi đã được thông báo và sẽ khắc phục càng sớm càng tốt. Nếu vấn đề vẫn tiếp tục, vui lòng",
    contactUs: "Liên hệ với chúng tôi.",
    language: "Ngôn ngữ",
    loading: "Đang tải...",
    loadingText: "Đang tải",
    save: "Lưu",
    savedSuccessfully: "Lưu Thành Công",
    saving: "Đang lưu...",
    cancel: "Hủy",
    edit: "Chỉnh sửa",
    delete: "Xóa",
    add: "Thêm",
    search: "Tìm kiếm",
    filter: "Lọc",
    clear: "Xóa",
    preview: "Xem trước",
    default: "Mặc định: {{value}}",
    optional: "Tùy chọn",
    required: "Bắt buộc",
    noData: "Không có dữ liệu",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Địa điểm",
      cities: "Thành phố", 
      regions: "Vùng",
      countries: "Quốc gia",
      showOnMap: "Hiển thị trên bản đồ",
      addLocation: "Thêm địa điểm"
    },
    welcome: {
      title: "Chào mừng đến với Locations So Super.",
      subtitle: "Chọn một phần từ điều hướng để bắt đầu."
    }
  },

  // Cities section
  cities: {
    title: "Thành phố",
    resourceSingular: "thành phố",
    resourcePlural: "thành phố",
    headings: {
      name: "Tên",
      status: "Trạng thái",
      locations: "Địa điểm", 
      region: "Vùng",
      country: "Quốc gia"
    },
    breadcrumbs: {
      cities: "Thành phố"
    }
  },

  // Countries section  
  countries: {
    title: "Quốc gia",
    resourceSingular: "quốc gia", 
    resourcePlural: "quốc gia",
    headings: {
      name: "Tên",
      status: "Trạng thái",
      locations: "Địa điểm",
      cities: "Thành phố",
      regions: "Vùng"
    },
    breadcrumbs: {
      countries: "Quốc gia"
    }
  },

  // Regions section
  regions: {
    title: "Vùng",
    resourceSingular: "vùng",
    resourcePlural: "vùng", 
    headings: {
      name: "Tên",
      status: "Trạng thái",
      locations: "Địa điểm",
      cities: "Thành phố",
      country: "Quốc gia"
    },
    breadcrumbs: {
      regions: "Vùng"
    }
  },

  // Map section
  map: {
    title: "Bản đồ",
    breadcrumbs: {
      locations: "Địa điểm"
    }
  },

  // Import section
  import: {
    title: "Nhập CSV",
    breadcrumbs: {
      locations: "Địa điểm"
    },
    new: {
      title: "Nhập địa điểm bằng CSV",
      description: "Tải xuống mẫu CSV để xem ví dụ về định dạng yêu cầu",
      sampleTemplate: "mẫu CSV",
      uploadAndContinue: "Tải lên và tiếp tục",
      abortOnError: "Dừng khi có lỗi",
      abortOnErrorHelp: "Nếu có lỗi, quá trình nhập sẽ dừng, hiển thị lỗi và không có địa điểm nào được nhập.",
      needHelp: "Cần trợ giúp nhập địa điểm?"
    },
    show: {
      title: "Nhập CSV",
      youCanLeavePage: "Bạn có thể rời khỏi trang này",
      backgroundMessage: "Quá trình nhập của bạn sẽ vẫn chạy trong nền",
      importProgress: "Tiến trình nhập",
      imported: "Đã nhập",
      suffix: "địa điểm",
      importLog: "Nhật ký nhập",
      cancelImport: "Hủy nhập",
      cancelConfirmation: {
        title: "Hủy nhập",
        message: "Bạn có chắc chắn muốn hủy công việc nhập này không? Hành động này không thể hoàn tác.",
        note: "Lưu ý: Đối với các công việc đang tiến hành, công việc sẽ cần hoàn thành và sẽ bị xóa ngay sau đó.",
        yesCancel: "Có, hủy nhập",
        noContinue: "Không, tiếp tục nhập"
      },
      report: "Báo cáo",
      failedLocations: "Địa điểm thất bại",
      uploadAnother: "Tải lên CSV khác",
      backToLocations: "Quay lại địa điểm",
      importSucceeded: "Nhập thành công",
      importFailed: "Nhập thất bại"
    },
    messages: {
      uploadSuccess: "Tải lên CSV thành công",
      uploadError: "Không thể tải lên CSV",
      pending: "Nhập chưa bắt đầu",
      inProgress: "Đang nhập",
      completed: "Nhập hoàn tất",
      invalidHeader: "Các cột sau là bắt buộc",
      invalidCsvFile: "Tệp CSV không hợp lệ",
      aborted: "Nhập bị hủy",
      failed: "Nhập thất bại",
      cancelled: "Nhập bị hủy"
    },
    errors: {
      csvTooLarge: "CSV quá lớn",
      languageNotEnabled: "Ngôn ngữ '{{language}}' chưa được bật cho cửa hàng này. Vui lòng bật trong Cài đặt > Ngôn ngữ trước.",
      fieldNotTranslatable: "Trường '{{field}}' không thể dịch. Các trường có thể dịch: {{fields}}",
      locationError: "Địa điểm với slug: {{slug}} - {{error}}",
      planLimit: "Bạn đã đạt giới hạn kế hoạch cho địa điểm"
    }
  },

  // Location form
  location: {
    index: {
      title: "Địa điểm",
      addLocation: "Thêm địa điểm",
      import: "Nhập",
      noPrioritySet: "Chưa đặt ưu tiên",
      published: "Đã xuất bản",
      draft: "Bản nháp",
      resourceSingular: "địa điểm",
      resourcePlural: "địa điểm",
      headings: {
        name: "Tên",
        status: "Trạng thái", 
        city: "Thành phố",
        region: "Vùng",
        country: "Quốc gia",
        priority: "Ưu tiên"
      }
    },
    form: {
      title: "Thêm địa điểm",
      editTitle: "Chỉnh sửa địa điểm",
      basicInformation: "Thông tin cơ bản",
      name: "Tên",
      namePlaceholder: "vd. Brians Bricks",
      nameHelpDefault: "Mặc định: {{defaultName}}",
      details: "Chi tiết",
      description: "Mô tả",
      descriptionPlaceholder: "Cho khách hàng biết điều gì làm cho địa điểm này đặc biệt",
      address: "Địa chỉ",
      addressPlaceholder: "123 Đường chính, Thành phố, Quốc gia",
      addressLine1: "Dòng địa chỉ 1",
      addressLine2: "Dòng địa chỉ 2",
      postalZipCode: "Mã bưu điện / ZIP",
      city: "Thành phố",
      stateProvinceRegion: "Tiểu bang / Tỉnh / Vùng",
      country: "Quốc gia",
      phone: "Điện thoại",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Email", 
      emailPlaceholder: "store@example.com",
      website: "Trang web",
      websitePlaceholder: "https://www.example.com",
      image: "Hình ảnh",
      imagePlaceholder: "Nhập URL hình ảnh",
      status: "Trạng thái",
      statusActive: "Hoạt động",
      statusInactive: "Không hoạt động",
      statusDraft: "Bản nháp",
      priority: "Ưu tiên",
      priorityHelpText: "Địa điểm có ưu tiên cao hơn sẽ xuất hiện trước trong kết quả tìm kiếm",
      findOnMapButton: "Tìm trên bản đồ"
    },
    validation: {
      addressNotFound: "Không tìm thấy địa chỉ",
      createSuccess: "Tạo địa điểm thành công", 
      updateSuccess: "Cập nhật địa điểm thành công",
      checkFields: "Vui lòng kiểm tra các trường của bạn",
      findOnMap: "Vui lòng tìm địa điểm của bạn trên bản đồ trước khi lưu"
    },
    errors: {
      loading: "Lỗi tải địa điểm"
    },
    actions: {
      save: "Lưu địa điểm",
      delete: "Xóa địa điểm",
      preview: "Xem trước"
    },
    customFields: {
      title: "Trường tùy chỉnh",
      noCustomFields: "Chưa cấu hình trường tùy chỉnh",
      configureFields: "Cấu hình trường",
      emptyState: "Bạn chưa cấu hình bất kỳ trường tùy chỉnh nào. Trường tùy chỉnh cho phép bạn thêm thông tin bổ sung cụ thể cho nhu cầu kinh doanh của bạn."
    },
    openingHours: {
      title: "Giờ mở cửa",
      checkboxLabel: "Địa điểm này có giờ mở và đóng cửa",
      statusOpen: "Mở",
      statusOpen24h: "Mở 24H",
      statusClosed: "Đóng",
      openingTimeLabel: "Giờ mở cửa",
      closingTimeLabel: "Giờ đóng cửa",
      days: {
        monday: "Thứ Hai",
        tuesday: "Thứ Ba", 
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        sunday: "Chủ Nhật"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Mới thêm gần đây",
        recentlyModified: "Mới chỉnh sửa gần đây"
      },
      filters: {
        status: "Trạng thái",
        taggedWith: "Được gắn thẻ với",
        locationStatus: "Trạng thái địa điểm",
        noTagsToShow: "Không có thẻ để hiển thị",
        searchPlaceholder: "Tìm kiếm"
      },
      bulkActions: {
        setPublished: "Đặt là đã xuất bản",
        setUnpublished: "Đặt là chưa xuất bản", 
        setPriority: "Đặt ưu tiên",
        deleteLocations: "Xóa địa điểm",
        exportCSV: "Xuất CSV"
      },
      appliedFilters: {
        statusIs: "Trạng thái là {{status}}",
        taggedWith: "Được gắn thẻ với {{tag}}",
        nameIncludes: "Tên bao gồm {{search}}"
      },
      modals: {
        deleteTitle: "Xóa địa điểm",
        deleteMessage: "Bạn có chắc chắn muốn xóa {{count}}?",
        deleteMessageAll: "Bạn có chắc chắn muốn xóa tất cả địa điểm?",
        prioritiseTitle: "Ưu tiên {{count}} địa điểm",
        prioritiseTitleAll: "Ưu tiên tất cả địa điểm",
        delete: "Xóa",
        cancel: "Hủy"
      },
      emptyState: {
        noResultsHeading: "Không tìm thấy {{resourcePlural}}",
        noResultsText: "Thử thay đổi bộ lọc hoặc từ khóa tìm kiếm",
        noDataHeading: "Thêm địa điểm để điền {{resourcePlural}}",
        addLocation: "Thêm địa điểm",
        importFromCSV: "Nhập từ CSV"
      },
      pagination: {
        label: "Trang {{page}} của {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Cập nhật thành công",
        deletedSuccessfully: "Xóa thành công", 
        exportedSuccessfully: "Xuất thành công",
        error: "Đã xảy ra lỗi"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Nội dung trang",
    editTemplate: "Chỉnh sửa mẫu SEO", 
    pageTitle: "Tiêu đề",
    pageDescription: "Mô tả",
    metaTitle: "Tiêu đề",
    metaDescription: "Mô tả",
    urlHandle: "Xử lý URL",
    searchEnginePreview: "Xem trước danh sách công cụ tìm kiếm",
    editMeta: "Chỉnh sửa Meta",
    previewMeta: "Xem trước Meta",
    loading: "Đang tải...",
    editingLocaleHelp: "Chỉnh sửa nội dung {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Mẫu SEO",
    breadcrumbs: {
      seoTemplates: "Mẫu SEO"
    },
    template: {
      title: "Mẫu {{templateName}} - {{locale}}",
      discardChanges: "Hủy thay đổi"
    },
    form: {
      pageContent: "Nội dung trang",
      searchEnginePreview: "Xem trước danh sách công cụ tìm kiếm",
      title: "Tiêu đề",
      description: "Mô tả",
      pageTitle: "Tiêu đề trang",
      metaDescription: "Mô tả Meta",
      editingLocaleHelp: "Chỉnh sửa bản dịch {{locale}}. Các trường trống sẽ hiển thị nội dung từ {{defaultLocale}}.",
      defaultValue: "Mặc định: {{value}}"
    },
    language: {
      label: "Ngôn ngữ",
      defaultHelp: "Đây là ngôn ngữ mặc định của bạn",
      editingHelp: "Chỉnh sửa bản dịch {{locale}}. Các trường trống sẽ hiển thị nội dung {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Đa ngôn ngữ chưa được bật",
      enableInSettings: "Bật trong Cài đặt",
      multipleLanguagesInfo: "Để quản lý mẫu SEO cho nhiều ngôn ngữ, bật quốc tế hóa trong cài đặt ngôn ngữ của bạn. Hiện tại chỉ hiển thị mẫu {{locale}}."
    },
    badges: {
      errors: "Lỗi!",
      unsaved: "Chưa lưu"
    },
    messages: {
      saveSuccess: "Mẫu SEO đã lưu thành công",
      saveError: "Không thể lưu mẫu",
      error: "Lỗi..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Thông tin cơ bản",
      name: "Tên",
      save: "Lưu",
      saving: "Đang lưu...",
      cancel: "Hủy",
      yourLocationsIn: "Địa điểm của bạn trong {{name}}",
      tableHeadings: {
        name: "Tên",
        status: "Trạng thái",
        city: "Thành phố",
        region: "Vùng",
        country: "Quốc gia"
      },
      resourceName: {
        singular: "địa điểm {{name}}",
        plural: "địa điểm trong {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Bản đồ",
      tags: "Thẻ",
      customFields: "Trường tùy chỉnh",
      languages: "Ngôn ngữ",
      plan: "Kế hoạch",
      addTag: "Thêm thẻ",
      addField: "Thêm trường"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Sắp kết thúc"
    },
    common: {
      loading: "Đang tải...",
      error: "Lỗi...",
      breadcrumbs: {
        settings: "Cài đặt"
      },
      skeleton: {
        customFields: "Trường tùy chỉnh",
        addField: "Thêm trường",
        name: "Tên",
        contentType: "Loại nội dung",
        usedIn: "Sử dụng trong",
        field: "Trường",
        fields: "Trường"
      },
      messages: {
        savedSuccessfully: "Cài đặt {{setting}} đã lưu thành công",
        couldntSave: "Không thể lưu cài đặt {{setting}}"
      }
    },
    map: {
      title: "Bản đồ",
      messages: {
        savedSuccessfully: "Cài đặt bản đồ đã lưu thành công",
        couldntSave: "Không thể lưu cài đặt"
      },
      mapboxToken: {
        title: "Token Mapbox",
        description: "Nhập token Mapbox của bạn để cung cấp năng lượng cho bộ định vị cửa hàng",
        label: "Token Mapbox",
        placeholder: "Nhập token ở đây để tiếp tục sử dụng bản đồ của bạn.",
        placeholderManaged: "Nhập token ở đây để tiếp tục sử dụng bản đồ của bạn khi bạn hết lượt tải bản đồ miễn phí.",
        helpText: "Làm theo hướng dẫn của chúng tôi để tạo khóa Mapbox, sau đó dán khóa của bạn ở trên. Nếu bạn gặp bất kỳ vấn đề nào, vui lòng liên hệ để được hỗ trợ.",
        linkInstructions: "hướng dẫn tạo khóa Mapbox",
        linkSupport: "liên hệ để được hỗ trợ"
      },
      managedToken: {
        title: "Tải bản đồ",
        description: "Bạn có tối đa {{max}} lượt tải bản đồ miễn phí với token được quản lý, sau đó bạn sẽ phải tạo token của riêng mình."
      },
      appearance: {
        title: "Giao diện",
        description: "Thay đổi hình ảnh của bản đồ"
      },
      mapStyle: {
        title: "Kiểu bản đồ",
        options: {
          streets: "Đường phố",
          outdoors: "Ngoài trời", 
          light: "Sáng",
          dark: "Tối",
          satellite: "Vệ tinh",
          satelliteStreets: "Đường phố vệ tinh",
          navigationDay: "Điều hướng ngày",
          navigationNight: "Điều hướng đêm"
        }
      },
      searchBehaviour: {
        title: "Hành vi tìm kiếm",
        description: "Điều khiển cách khách truy cập tìm địa điểm trên bản đồ của bạn.",
        geolocateLabel: "Tự động ước tính vị trí của khách truy cập và hiển thị các cửa hàng gần đó",
        geolocateHelp: "Nếu định vị địa lý thành công, bản đồ sẽ di chuyển để tập trung gần khách truy cập. Nếu không tìm thấy vị trí ước tính, bản đồ sẽ ở vị trí bắt đầu.",
        filterBehaviour: {
          title: "Hành vi lọc",
          all: {
            label: "Tất cả thẻ",
            help: "Để một địa điểm xuất hiện trong bộ lọc, nó phải có tất cả các thẻ được chọn"
          },
          any: {
            label: "Bất kỳ thẻ nào", 
            help: "Để một địa điểm xuất hiện trong bộ lọc, nó có thể có bất kỳ thẻ nào được chọn"
          }
        },
        keepSearchInView: {
          label: "Giữ điểm đánh dấu tìm kiếm trong tầm nhìn",
          help: "Khi kết quả tìm kiếm xuất hiện, bản đồ sẽ thu nhỏ để hiển thị tất cả các địa điểm phù hợp"
        },
        distanceUnits: {
          title: "Đơn vị khoảng cách",
          km: "Kilômét",
          miles: "Dặm"
        },
        maxResults: {
          label: "Kết quả tối đa",
          help: "Giới hạn số lượng địa điểm hiển thị trong kết quả tìm kiếm",
          options: {
            results30: "30 kết quả"
          }
        },
        maxDistance: {
          label: "Khoảng cách tối đa", 
          help: "Chỉ hiển thị các địa điểm trong khoảng cách này từ điểm tìm kiếm",
          options: {
            unlimited: "Không giới hạn"
          }
        },
        showLocationNames: {
          label: "Hiển thị tên địa điểm trong gợi ý",
          help: "Hiển thị tên địa điểm trong gợi ý tìm kiếm"
        },
        sortByPriority: {
          label: "Sắp xếp theo ưu tiên thay vì khoảng cách",
          help: "Rất khuyến nghị đặt khoảng cách tối đa (không phải Không giới hạn) nếu hộp này được chọn. Nếu không, khách hàng của bạn sẽ thấy các địa điểm xa có ưu tiên cao được liệt kê trên những địa điểm trong khoảng cách hợp lý từ họ."
        }
      },
      searchResults: {
        title: "Kết quả tìm kiếm",
        description: "Điều khiển cách các địa điểm được trả về trên bản đồ của bạn.",
        locationsLabel: "Văn bản kết quả tìm kiếm",
        locationsHelp: "Văn bản hiển thị trên kết quả tìm kiếm (vd., 'Hiển thị 5 địa điểm')",
        prefixLabel: "Tiền tố kết quả tìm kiếm", 
        prefixHelp: "Văn bản hiển thị trước số lượng kết quả"
      },
      popups: {
        title: "Cửa sổ bật lên",
        showPopups: {
          label: "Hiển thị cửa sổ bật lên",
          help: "Hiển thị chi tiết địa điểm khi khách truy cập nhấp vào điểm đánh dấu trên bản đồ"
        }
      },
      whitelabel: {
        title: "Nhãn trắng",
        hideLabel: "Ẩn văn bản được cung cấp bởi",
        hideHelp: "Xóa thương hiệu của chúng tôi khỏi bộ định vị cửa hàng của bạn"
      }
    },
    languages: {
      title: "Ngôn ngữ",
      error: "Lỗi...",
      messages: {
        savedSuccessfully: "Cài đặt ngôn ngữ đã lưu thành công",
        couldntSave: "Không thể lưu cài đặt ngôn ngữ"
      },
      banner: {
        upgradeTitle: "Hỗ trợ đa ngôn ngữ yêu cầu nâng cấp kế hoạch",
        upgradeAction: "Nâng cấp lên Superest",
        upgradeMessage: "Bạn vẫn có thể thay đổi ngôn ngữ mặc định, nhưng bật đa ngôn ngữ yêu cầu nâng cấp.",
        disabledMessage: "Cài đặt đa ngôn ngữ bị vô hiệu hóa trên kế hoạch hiện tại của bạn"
      },
      defaultLanguage: {
        title: "Ngôn ngữ mặc định", 
        description: "Chọn ngôn ngữ chính mà nội dung của bạn sẽ được hiển thị.",
        label: "Ngôn ngữ mặc định",
        help: "Ngôn ngữ này sẽ được sử dụng khi không có ngôn ngữ cụ thể được yêu cầu"
      },
      internationalization: {
        title: "Quốc tế hóa",
        description: "Bật nhiều ngôn ngữ. Tiếp cận nhiều khách hàng hơn và tăng cường SEO của bạn.",
        enableLabel: "Bật đa ngôn ngữ",
        enableHelp: "Cho phép khách hàng xem bộ định vị cửa hàng của bạn bằng các ngôn ngữ khác nhau"
      },
      supportedLanguages: {
        title: "Ngôn ngữ được hỗ trợ bổ sung",
        description: "Chọn các ngôn ngữ bạn muốn hỗ trợ. Sau khi bật ngôn ngữ, bạn sẽ thấy các tùy chọn để dịch toàn bộ ứng dụng. Đối với các ngôn ngữ được hỗ trợ, các mẫu SEO chung và mẫu biến chủ đề sẽ được tạo tự động.",
        defaultLocaleNote: "Đây là ngôn ngữ mặc định của bạn và không thể bị vô hiệu hóa",
        shopifyEnabled: {
          label: "Ngôn ngữ này được bật trong cửa hàng Shopify của tôi",
          importantNote: "Quan trọng:",
          description: "Bỏ chọn hộp trên nếu ngôn ngữ này chưa được bật và xuất bản cho cửa hàng Shopify của bạn. Bạn nên bật ngôn ngữ trong cửa hàng Shopify của mình trước bằng cách vào Cài đặt > Ngôn ngữ trong bảng điều khiển Shopify của bạn nếu chưa làm"
        },
        urlFormats: {
          cleanUrls: "URL sạch:",
          betterSeo: "SEO và trải nghiệm người dùng tốt hơn",
          queryUrls: "URL tham số truy vấn:",
          considerEnabling: "Cân nhắc bật trong Shopify để có URL tốt hơn"
        },
        preview: {
          button: "Xem trước",
          tooltip: "Xem trước bộ định vị cửa hàng {{language}}"
        },
        tooltips: {
          noTemplates: "Không có mẫu SEO mặc định cho ngôn ngữ này. Bạn có thể tạo bản dịch tùy chỉnh dễ dàng"
        }
      }
    },
    tags: {
      title: "Thẻ",
      addTag: "Thêm thẻ",
      error: "Lỗi",
      messages: {
        deletedSuccessfully: "Thẻ đã xóa thành công",
        couldntDelete: "Không thể xóa thẻ",
        savedSuccessfully: "Thẻ đã lưu thành công",
        couldntSave: "Vui lòng kiểm tra các trường của bạn",
        tagDeleted: "Thẻ đã xóa thành công"
      },
      resourceName: {
        singular: "Thẻ",
        plural: "Thẻ"
      },
      filters: {
        anyGroup: "Bất kỳ nhóm nào",
        inGroup: "Trong nhóm",
        tagGroup: "Nhóm thẻ"
      },
      appliedFilters: {
        inGroup: "Trong nhóm {{group}}",
        nameContains: "Tên thẻ chứa tìm kiếm {{query}}"
      },
      bulkActions: {
        deleteTag: "Xóa thẻ",
        deleteTags: "Xóa thẻ"
      },
      form: {
        language: "Ngôn ngữ",
        title: "Tiêu đề",
        description: "Mô tả",
        group: "Nhóm",
        groupPlaceholder: "Chọn nhóm",
        addGroup: "Thêm",
        editingTranslations: "Chỉnh sửa bản dịch {{language}}. Các trường trống sẽ hiển thị nội dung từ {{defaultLanguage}}.",
        defaultValue: "Mặc định: {{value}}",
        image: "Hình ảnh",
        imageUrl: "URL hình ảnh"
      },
      actions: {
        save: "Lưu",
        deleteTag: "Xóa thẻ"
      },
      new: {
        title: "Thêm thẻ",
        messages: {
          createSuccess: "Thẻ đã tạo thành công",
          checkFields: "Vui lòng kiểm tra các trường của bạn"
        },
        actions: {
          createTag: "Tạo thẻ"
        }
      }
    },
    customFields: {
      title: "Trường tùy chỉnh",
      addField: "Thêm trường",
      error: "Lỗi",
      resourceName: {
        singular: "Trường",
        plural: "Trường"
      },
      headings: {
        name: "Tên",
        contentType: "Loại nội dung",
        usedIn: "Sử dụng trong"
      },
      emptyState: {
        heading: "Tạo và quản lý các trường tùy chỉnh của bạn",
        createAction: "Tạo trường",
        description: "Sử dụng trường tùy chỉnh cho các đặc điểm cụ thể của doanh nghiệp của bạn. Các trường này có thể là liên kết mạng xã hội hoặc tên quản lý cửa hàng và email"
      },
      pluralization: {
        location: "địa điểm",
        locations: "địa điểm"
      },
      form: {
        name: "Tên",
        contentType: "Loại nội dung",
        key: "Khóa",
        keyPrefix: "location.fields.",
        keyHelp: "Sử dụng khóa này để truy cập nội dung của địa điểm {{name}} trong mẫu của bạn",
        translations: {
          title: "Bản dịch",
          showTranslations: "Hiển thị bản dịch",
          hideTranslations: "Ẩn bản dịch",
          description: "Bản dịch là tùy chọn. Nếu trường trống, tên trường {{language}} sẽ được hiển thị.",
          nameTranslation: "Tên ({{language}})",
          defaultValue: "Mặc định: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Trường đã lưu thành công",
        couldntSave: "Không thể lưu trường",
        deletedSuccessfully: "Trường đã xóa thành công",
        couldntDelete: "Không thể xóa trường"
      },
      actions: {
        delete: "Xóa"
      },
      new: {
        title: "Thêm trường",
        messages: {
          savedSuccessfully: "Trường đã lưu thành công",
          couldntSave: "Không thể lưu trường"
        }
      },
      contentTypes: {
        text: "Văn bản",
        textArea: "Vùng văn bản",
        email: "Email",
        number: "Số",
        phoneNumber: "Số điện thoại",
        time: "Thời gian",
        url: "URL"
      }
    },
    plan: {
      title: "Kế hoạch",
      error: "Lỗi",
      changePlan: "Thay đổi kế hoạch",
      usdPerMonth: "USD / tháng",
      sections: {
        yourPlanIncludes: "Kế hoạch của bạn bao gồm",
        nextBillingDate: "Ngày thanh toán tiếp theo",
        trial: "Dùng thử"
      },
      banners: {
        planUpdated: "Kế hoạch của bạn đã được cập nhật",
        thankYouUpgrading: "Cảm ơn bạn đã nâng cấp!",
        letUsKnow: "Hãy cho chúng tôi biết",
        improvementText: "nếu có điều gì chúng tôi có thể cải thiện",
        trialCancellation: {
          title: "Thông báo hủy dùng thử",
          message: "Bản dùng thử miễn phí 14 ngày của bạn sẽ bị hủy khi bạn nâng cấp lên gói trả phí."
        }
      },
      locations: {
        upTo: "Lên đến",
        locations: "địa điểm",
        unlimited: "Địa điểm không giới hạn",
        used: "Đã sử dụng",
        ofUsed: "{{used}} của {{max}} đã sử dụng"
      },
      trial: {
        daysLeft: "{{days}} ngày còn lại",
        daysUsed: "{{used}} của {{total}} ngày đã sử dụng",
        selectPlan: "Chọn kế hoạch",
        currentPlan: "Kế hoạch hiện tại",
        trialBadge: "Dùng thử",
        currentBadge: "Hiện tại",
        yourTrialJustStarted: "Dùng thử của bạn vừa bắt đầu",
        trialEndsAfterToday: "Dùng thử của bạn kết thúc sau hôm nay",
        trialEndsTomorrow: "Dùng thử của bạn kết thúc vào ngày mai",
        daysLeftInTrial: "{{days}} ngày còn lại trong dùng thử của bạn",
        continueAddingLocations: "Tiếp tục thêm địa điểm sau {{date}} bằng cách chọn kế hoạch",
        selectPlanToday: "Vui lòng chọn kế hoạch hôm nay để tiếp tục thêm địa điểm"
      },
      footer: {
        description: "Quản lý hoặc thay đổi kế hoạch Locations So Super của bạn. Xem điều khoản dịch vụ của chúng tôi",
        termsOfService: "Điều khoản dịch vụ",
        and: "và",
        privacyPolicy: "Chính sách bảo mật"
      },
      features: {
        analytics: {
          title: "Phân tích",
          description: "Tìm hiểu cách khách hàng sử dụng địa điểm của bạn và họ đang tìm kiếm gì"
        },
        internationalization: {
          title: "Hỗ trợ đa ngôn ngữ",
          description: "Tăng cường SEO và kinh doanh của bạn trên các thị trường mục tiêu bằng cách bật đa ngôn ngữ"
        },
        customThemes: {
          editLiquid: {
            title: "Chỉnh sửa mẫu chủ đề Liquid",
            description: "Hiển thị dữ liệu địa điểm theo cách bạn muốn với quyền truy cập chủ đề Liquid"
          },
          editStructuredData: {
            title: "Chỉnh sửa dữ liệu có cấu trúc doanh nghiệp",
            description: "Thay đổi cách Google hiểu tất cả các trang bằng cách chỉnh sửa dữ liệu có cấu trúc"
          }
        }
      },
      edit: {
        title: "Thay đổi kế hoạch",
        allPlansInclude: "Tất cả kế hoạch bao gồm",
        needingMoreLocations: "Cần thêm địa điểm?",
        footerQuestion: "Có câu hỏi trước khi bắt đầu?",
        sendMessage: "Gửi tin nhắn cho chúng tôi",
        allFeatures: {
          seoDirectory: {
            title: "Thư mục SEO và trang đích",
            description: "Tạo thư mục SEO cho tất cả địa điểm, thành phố và vùng của bạn"
          },
          mapPage: {
            title: "Trang bản đồ với tìm kiếm và lọc",
            description: "Tìm kiếm và lọc tất cả địa điểm trên bản đồ được hỗ trợ bởi Mapbox"
          },
          tags: {
            title: "Thẻ",
            description: "Tạo thẻ với hình ảnh và mô tả và nhóm chúng"
          },
          openingHours: {
            title: "Giờ mở cửa",
            description: "Đặt và hiển thị giờ mở cửa cho địa điểm của bạn"
          },
          mapStyles: {
            title: "Kiểu bản đồ",
            description: "Thay đổi giao diện của bản đồ với nhiều kiểu tùy chỉnh"
          },
          customFields: {
            title: "Trường tùy chỉnh",
            description: "Thêm các trường bạn muốn, từ liên kết mạng xã hội đến tên quản lý cửa hàng"
          },
          csvUpload: {
            title: "Tải lên và xuất với CSV",
            description: "Tải lên và chỉnh sửa địa điểm với ghi đè hàng loạt"
          },
          richSnippets: {
            title: "Snippet phong phú cho Google",
            description: "Giúp Google hiểu tất cả các trang với dữ liệu có cấu trúc doanh nghiệp địa phương"
          },
          directionsAndCalls: {
            title: "Chỉ đường và gọi điện",
            description: "Khách hàng có thể dễ dàng tìm chỉ đường và gọi điện cho địa điểm"
          },
          languageSupport: {
            title: "Hỗ trợ ngôn ngữ",
            description: "Thay đổi ngôn ngữ mặc định thành ngôn ngữ khác không phải tiếng Anh. Các mẫu được cung cấp có sẵn bản dịch cho 32 ngôn ngữ chính để dễ dàng thiết lập"
          }
        }
      },
      planCard: {
        bestToCustomize: "Tốt nhất để tùy chỉnh",
        currentPlan: "Kế hoạch hiện tại",
        chooseThisPlan: "Chọn kế hoạch này",
        locationsSection: "Địa điểm",
        featuresSection: "Tính năng",
        upTo: "Lên đến",
        locations: "địa điểm",
        tooltipTooManyLocations: "Bạn có quá nhiều địa điểm hoặc ngôn ngữ được bật cho kế hoạch này"
      },
      confirmation: {
        error: "Lỗi xác nhận kế hoạch"
      }
    }
  },

  // Themes section
  themes: {
    title: "Chủ đề",
    currentTheme: {
      title: "Chủ đề hiện tại",
      description: "Đây là chủ đề mà khách hàng thấy khi truy cập ứng dụng địa điểm của bạn"
    },
    themeLibrary: {
      title: "Mẫu chủ đề",
      description: "Quản lý mẫu chủ đề cho địa điểm của bạn. Thêm và xuất bản mẫu để thay đổi giao diện của địa điểm trực tuyến của bạn"
    },
    skeleton: {
      currentThemeDescription: "Đây là chủ đề mà khách hàng thấy khi truy cập ứng dụng địa điểm của bạn"
    },
    modal: {
      overrideTitle: "Truy cập chủ đề hiện tại?",
      override: "Truy cập",
      cancel: "Hủy",
      undoWarning: "Hành động này không thể hoàn tác"
    },
    messages: {
      publishSuccess: "Mẫu đã xuất bản thành công",
      publishError: "Không thể xuất bản mẫu",
      error: "Đã xảy ra lỗi"
    },
    emptyStates: {
      settings: {
        heading: "Chủ đề này không có cài đặt",
        description: "Tạo cài đặt trong trình chỉnh sửa mẫu",
        createSettings: "Tạo cài đặt",
        upgradePlan: "Nâng cấp kế hoạch",
        upgradeRequired: "Nâng cấp kế hoạch để tạo cài đặt"
      },
      language: {
        heading: "Chủ đề này không có mẫu ngôn ngữ",
        description: "Tạo mẫu ngôn ngữ trong trình chỉnh sửa mẫu",
        createLanguageTerms: "Tạo mẫu ngôn ngữ",
        upgradePlan: "Nâng cấp kế hoạch",
        upgradeRequired: "Nâng cấp kế hoạch để tạo mẫu ngôn ngữ"
      }
    },
    templates: {
      categories: {
        templates: "Mẫu",
        schemas: "Lược đồ",
        styles: "Kiểu",
        liquidReference: "Tham chiếu Liquid"
      },
      items: {
        landing: "Trang đích",
        directory: "Thư mục",
        country: "Quốc gia",
        region: "Vùng",
        city: "Thành phố",
        location: "Địa điểm",
        language: "Ngôn ngữ",
        settings: "Cài đặt",
        stylesheet: "Bảng kiểu"
      },
      errors: {
        errorsInTemplate: "Lỗi trong mẫu",
        error: "Lỗi"
      },
      badges: {
        errors: "Lỗi!",
        unsaved: "Chưa lưu"
      },
      actions: {
        viewTheme: "Xem chủ đề",
        discard: "Hủy",
        save: "Lưu"
      }
    },
    language: {
      messages: {
        saveSuccess: "Bản dịch mẫu chủ đề đã lưu thành công",
        saveError: "Không thể lưu mẫu"
      },
      form: {
        language: "Ngôn ngữ",
        defaultLanguageHelp: "Đây là ngôn ngữ mặc định của bạn",
        translationHelp: "Chỉnh sửa bản dịch {{selectedLocale}}. Các trường trống sẽ hiển thị nội dung từ {{defaultLocale}} (ngôn ngữ mặc định của bạn)"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Đa ngôn ngữ chưa được bật",
          action: "Bật trong Cài đặt",
          description: "Để quản lý bản dịch, bật quốc tế hóa trong cài đặt ngôn ngữ của bạn. Hiện tại chỉ hiển thị mẫu bản dịch {{locale}}"
        },
        translating: {
          title: "Dịch từ {{from}} sang {{to}}",
          description: "Các trường trống sẽ tự động hiển thị nội dung người dùng {{defaultLocale}}, nhưng bạn chỉ cần dịch các trường cần nội dung khác nhau trong {{selectedLocale}}"
        }
      },
      accessLanguageTerms: "Truy cập mẫu ngôn ngữ {{category}} với {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Tiêu đề",
        description: "Mô tả",
        heading: "Tiêu đề",
        subheading: "Tiêu đề phụ",
        button_text: "Văn bản nút",
        link_text: "Văn bản liên kết",
        placeholder: "Trình giữ chỗ",
        label: "Nhãn",
        help_text: "Văn bản trợ giúp",
        error_message: "Thông báo lỗi",
        success_message: "Thông báo thành công",

        // Opening hours
        Monday: "Thứ Hai",
        Tuesday: "Thứ Ba",
        Wednesday: "Thứ Tư",
        Thursday: "Thứ Năm",
        Friday: "Thứ Sáu",
        Saturday: "Thứ Bảy",
        Sunday: "Chủ Nhật",
        opening_hours_format: "Định dạng giờ mở cửa",
        closes_at_format: "Định dạng đóng cửa lúc",
        opens_at_format: "Định dạng mở cửa lúc",
        opens_on: "Mở cửa vào",
        open_24h: "Mở 24 giờ",
        open: "Mở",
        closed: "Đóng",
        closes_at: "Đóng cửa lúc",
        opens_at: "Mở cửa lúc",

        // Map
        search_map: "Tìm kiếm bản đồ",
        search_area: "Tìm kiếm khu vực này",
        view_map: "Bản đồ",
        view_list: "Danh sách",
        open_filters: "Bộ lọc",
        stores_near_you: "Cửa hàng gần bạn",
        header: "Tìm cửa hàng!",
        search_placeholder: "Nhập mã bưu điện hoặc địa chỉ...",
        no_listings: "Chúng tôi đã tìm khắp thế giới nhưng không tìm thấy địa điểm nào cho tìm kiếm của bạn. Thử thay đổi bộ lọc hoặc vị trí tìm kiếm",

        // Directory
        view_directory: "Thư mục cửa hàng",

        // Location
        get_directions: "Lấy chỉ đường",
        call: "Gọi",
        view_website: "Trang web",
        email: "Email",
        opening_hours_header: "Giờ mở cửa",
        description_header: "Thông tin",
        phone_number_header: "Số điện thoại",
        address_header: "Địa chỉ",
        tag_groups_to_display: "Nhóm thẻ để hiển thị"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Chung",
        navigation: "Điều hướng",
        forms: "Biểu mẫu",
        buttons: "Nút",
        messages: "Tin nhắn",
        errors: "Lỗi",
        opening_hours: "Giờ mở cửa",
        map: "Bản đồ",
        directory: "Thư mục",
        location: "Địa điểm"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Chủ đề đã lưu thành công",
        saveError: "Không thể lưu chủ đề"
      },
      accessSettings: "Truy cập cài đặt {{category}} với {{code}}",
      fields: {
        // Colors
        color_text: "Màu văn bản",
        color_text_heading: "Màu văn bản tiêu đề",
        color_background: "Màu nền",
        color_accent: "Màu nhấn",
        color_text_positive: "Màu văn bản tích cực",
        color_text_negative: "Màu văn bản tiêu cực",
        dark_theme: "Chủ đề tối",
        color_marker: "Màu điểm đánh dấu",
        color_search_marker: "Màu điểm đánh dấu tìm kiếm",

        // Typography
        base_font_size: "Kích thước phông chữ cơ bản",

        // Buttons
        border_radius: "Bán kính viền",

        // Images
        aspect_ratio: "Tỷ lệ khung hình",
        fit: "Vừa vặn",

        // Spacing
        page_width: "Chiều rộng trang",
        page_width_small: "Chiều rộng trang nhỏ",
        gutter_desktop: "Khoảng trống máy tính",
        gutter_mobile: "Khoảng trống di động",
        desktop_vertical_spacing: "Khoảng trống dọc máy tính",
        mobile_vertical_spacing: "Khoảng trống dọc di động",

        // Breakpoints
        breakpoint_xs: "Điểm ngắt XS",
        breakpoint_sm: "Điểm ngắt SM",
        breakpoint_md: "Điểm ngắt MD",

        // Map
        search_on_move: "Tìm kiếm khi di chuyển",
        scroll_to_zoom: "Cuộn để thu phóng",

        // Landing page
        sidebar_width: "Chiều rộng thanh bên",
        sidebar_min_height: "Chiều cao tối thiểu thanh bên",
        marker_image_src: "Nguồn hình ảnh điểm đánh dấu",
        show_filter_descriptions: "Hiển thị mô tả bộ lọc",

        // Location page
        tag_groups_to_display: "Nhóm thẻ để hiển thị",
        tag_groups_to_display_as_icons: "Nhóm thẻ để hiển thị dưới dạng biểu tượng",
        show_related_locations: "Hiển thị địa điểm liên quan",

        // Locations
        hide_regions: "Ẩn vùng"
      },
      categories: {
        colors: "Màu sắc",
        typography: "Kiểu chữ",
        buttons: "Nút",
        images: "Hình ảnh",
        spacing: "Khoảng trống",
        breakpoints: "Điểm ngắt",
        map: "Bản đồ",
        landing_page: "Trang đích",
        location_page: "Trang địa điểm",
        locations: "Địa điểm"
      }
    },
    navigation: {
      sublimeTheme: "Chủ đề Sublime",
      settings: "Cài đặt",
      language: "Ngôn ngữ",
      templates: "Mẫu",
      changeTheme: "Thay đổi chủ đề",
      viewDirectory: "Xem thư mục",
      viewLandingPage: "Xem trang đích"
    },
    card: {
      lastUpdated: "Cập nhật lần cuối",
      view: "Xem",
      customize: "Tùy chỉnh",
      publish: "Xuất bản",
      actions: "Hành động"
    }
  },

  // Analytics section
  analytics: {
    title: "Phân tích",
    timePeriods: {
      last7days: "7 ngày qua",
      last30days: "30 ngày qua"
    },
    comparison: {
      compareToPrevious: "So sánh với khoảng thời gian trước",
      stopComparing: "Dừng so sánh với khoảng thời gian trước"
    },
    sections: {
      searchLocations: "Tìm kiếm địa điểm"
    },
    cards: {
      sessions: "Phiên",
      topSearches: "Tìm kiếm phổ biến nhất",
      topLandingPageType: "Loại trang đích phổ biến nhất",
      topPageViewsBySession: "Trang xem nhiều nhất theo phiên",
      topLocations: "Địa điểm phổ biến nhất",
      topReferrers: "Nguồn giới thiệu phổ biến nhất",
      searches: "Tìm kiếm",
      topLandingPagesBySession: "Trang đích xem nhiều nhất theo phiên"
    },
    chartLabels: {
      desktop: "Máy tính"
    }
  },

}; 